import Selector from '../selector';
import { CellRange } from '../../core/cell_range';

export default class BlockManage {
  constructor(overlayerCEl,data,table) {
    //image标签父级标签
    this.overlayerCEl = overlayerCEl;
    // selector
    this.selector = new Selector(data);
    this.data = data;
    this.table = table;

    //存储循环块、块显示信息
    this.blocksMsg = this.data.blocks || {
      //整体块设置
      block:[],
      //行循环块
      rowCycleBlock:[],
      //列循环块
      columnCycleBlock:[],
      //自定义变量块区域
      customVariableBlock:[],
    };
  }

  getBlockName(type,blockName){
    let text = '块';
    if (type == 'block') {
      text = '块';
    }else if (type == 'rowCycleBlock') {
      text = '行循环块';
    }else if (type == 'columnCycleBlock') {
      text = '列循环块';
    }else if (type == 'customVariableBlock') {
      text = blockName || '';
    }
    return text;
  }

  /**
   * 获取对应区域内的块信息
   * @param {*} selectRange 选择范围
   */
  getBlockWithRange(selectRange){
    if (selectRange) {
      for (const type in this.blocksMsg) {
        if (Object.hasOwnProperty.call(this.blocksMsg, type)) {
          const blockMsgArr = this.blocksMsg[type] || [];
          for (let index = 0; index < blockMsgArr.length; index++) {
            let element = blockMsgArr[index];
            let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
            if (range && range.intersects(selectRange)) {
              return element;
            }
          }
        }
      }
    }
    return null;
  }

  /**
   * 检测选择区域是否存在单元格设置块
   * @param {*} blockType  block:整体块,rowCycleBlock:行循环块,columnCycleBlock:列循环块,customVariableBlock:自定义变量块
   * @param {*} selectRange 选择范围
   */
  checkIsSetBlock(selectRange){
    if (selectRange) {
      for (const type in this.blocksMsg) {
        if (Object.hasOwnProperty.call(this.blocksMsg, type)) {
          const blockMsgArr = this.blocksMsg[type] || [];
          for (let index = 0; index < blockMsgArr.length; index++) {
            const element = blockMsgArr[index];
            let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
            if (range && range.intersects(selectRange)) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  //检查是否存在除了id之外的块重复设置
  checkIsSetOtherCustomVariableBlock(selectRange,type,oldBlock){
    if (selectRange) {
      let blockMsgArr = this.blocksMsg[type] || [];
      blockMsgArr = blockMsgArr.filter(item=>item.id != oldBlock.id);
      for (let index = 0; index < blockMsgArr.length; index++) {
        const element = blockMsgArr[index];
        let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
        if (range && range.intersects(selectRange)) {
          return true;
        }
      }
    }
    return false;
  }

  //检查是否存在id的块设置
  checkIsSetBlockWithKey(selectRange,type,id){
    if (selectRange) {
      let blockMsgArr = this.blocksMsg[type] || [];
      let index = blockMsgArr.findIndex(item=>item.id == id);
      if (index>=0) {
        return true
      }
    }
    return false;
  }

  //处理块显示位置Offset
  blockSetOffset(moveType,distance,data) {
    console.log("ImageManage blockSetOffset......",moveType,distance );
    this.blocksArr.forEach(imgObj => {
      imgObj.setImageOffset(data,distance,moveType);
    });
  }

  //处理块设定
  blockSet(selectRange,type,data,blockConfig) {
    if (selectRange) {
      let blockMsgArr = this.blocksMsg[type] || [];
      let selectRect = data.getRect(selectRange);
      let isCoverSet = (blockConfig && blockConfig.isCoverSet) || false;
      if (isCoverSet) {
        let oldBlockId = blockConfig && blockConfig.oldBlock && blockConfig.oldBlock.id;
        let index = blockMsgArr.findIndex(item=>item.id == oldBlockId);
        if (index>=0) {
          blockMsgArr.splice(index,1,{
            range:{
              sri:selectRange.sri,
              sci:selectRange.sci,
              eri:selectRange.eri,
              eci:selectRange.eci,
              w:selectRect.width,
              h:selectRect.height},
            name: this.getBlockName(type,blockConfig && blockConfig.name),
            id:selectRange.toKeyString(),
            key:(blockConfig && blockConfig.key) || selectRange.toKeyString(),
            config:blockConfig && blockConfig.config,
            type});
        }else{
          blockMsgArr.push({
            range:{
              sri:selectRange.sri,
              sci:selectRange.sci,
              eri:selectRange.eri,
              eci:selectRange.eci,
              w:selectRect.width,
              h:selectRect.height},
            name: this.getBlockName(type,blockConfig && blockConfig.name),
            id:selectRange.toKeyString(),
            key:(blockConfig && blockConfig.key) || selectRange.toKeyString(),
            config:blockConfig && blockConfig.config,
            type});
        }
      }else{
        blockMsgArr.push({
          range:{
            sri:selectRange.sri,
            sci:selectRange.sci,
            eri:selectRange.eri,
            eci:selectRange.eci,
            w:selectRect.width,
            h:selectRect.height},
          name: this.getBlockName(type,blockConfig && blockConfig.name),
          id:selectRange.toKeyString(),
          key:(blockConfig && blockConfig.key) || selectRange.toKeyString(),
          config:blockConfig && blockConfig.config,
          type});
      }
      
      this.blocksMsg[type] = blockMsgArr;
      //设定canvas中区域块的边线
    }

    data.setBlocks(this.blocksMsg);
  }

  //处理块取消，只要选择区域单元格存在对应type的块设置，则取消
  blockCancel(selectRange,type,data,blockConfig) {
    if (selectRange) {
      console.log("blockCancel selectRange......",selectRange);
      console.log("blockCancel type......",type);
      console.log("blockCancel data......",data);
      let blockMsgArr = this.blocksMsg[type];
      if (blockMsgArr && blockMsgArr.length>0) {
        for (let index = 0; index < blockMsgArr.length; index++) {
          const element = blockMsgArr[index];
          console.log("blockCancel11......",element.range);
          let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
          if (range && range.intersects(selectRange)) {
            //删除canvas中区域的划线
            console.log("blockCancel22......",selectRange);
            //删除了缓存块数据
            blockMsgArr.splice(index,1);
            break;
          }
        }
      }
    }
    console.log("blockCancel33......",JSON.parse(JSON.stringify(this.blocksMsg)));
    data.setBlocks(this.blocksMsg);
  }

  setBlockMsg(blocks){
    this.blocksMsg = blocks;
  }
  //清空blocks通过key
  clearBlocksWithKey(type,key){
    let blockMsgArr = this.blocksMsg[type];
    if (blockMsgArr && blockMsgArr.length>0) {
      let arr = [...blockMsgArr];
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        console.log("blockCancel11......",element.range);
        if (element.key == key) {
          let deleteIndex = blockMsgArr.findIndex(item=>item.key==key);
          //删除了缓存块数据
          blockMsgArr.splice(deleteIndex,1);
        }
      }
    }
  }
  //清空blocks数据
  clearblocksArr(){
    
  }
  //更新块名称 通过key批量更新
  updateBlockNameWithKey(key,name,type){
    if (type) {
      let blockMsgArr = this.blocksMsg[type];
      if (blockMsgArr && blockMsgArr.length>0) {
        for (let index = 0; index < blockMsgArr.length; index++) {
          let element = blockMsgArr[index];
          if (element.key == key) {
            let newEle = {...element};
            newEle.name = this.getBlockName(type,name);
            blockMsgArr.splice(index,1,newEle);
          }
        }
      }
    }else{
      for (const type in this.blocksMsg) {
        if (Object.hasOwnProperty.call(this.blocksMsg, type)) {
          let blockMsgArr = this.blocksMsg[type] || [];
          for (let index = 0; index < blockMsgArr.length; index++) {
            let element = blockMsgArr[index];
            if (element.key == key) {
              let newEle = {...element};
              newEle.name = this.getBlockName(type,name);
              blockMsgArr.splice(index,1,newEle);
            }
          }
        }
      }
    }
    
  }
}
